
import Cookies from 'js-cookie'

const BSRS_ACCESS_TOKEN = 'bsrs_access_token'
const ACCESS_TOKEN = 'access_token'
const SERVICE_TOKEN = 'service_token'
const O365_TOKEN = 'o365_token'
const EXPIRES_ON = 'expires_on'
const REFRESH_TOKEN = 'refresh_token'
const SERVICE_TOKEN_EXPIRES = 'service_token_expires_on'
const IS_INTEGRATION = 'isIntegration'
const USER_ID = 'id'
const O365_EXPIRES_ON = 'o365_expires_on'
const USER_EMAIL = 'email'
const TOKEN_EXPIRE = 'token_expire'
const IS_USER_AD = 'isUserActiveDirectory'
const TIME_ZONE = 'timeZone'
const SERVICE = 'service'
const FIRSTNAME = 'firstName'
const LASTNAME = 'lastName'

function getCookie(key) {
    return Cookies.get(key)
}

function setCookie(key, value) {
    Cookies.set(key, value)
}

function removeCookie(key) {
    Cookies.remove(key)
}

export function getIsUserActiveDirectory() {
    return getCookie(IS_USER_AD)
}

export function getAccessToken() {
    return getCookie(SERVICE_TOKEN)
}

export function getO365Token() {
    return getCookie(O365_TOKEN)
}

export function getIsIntegration() {
    return getCookie(IS_INTEGRATION)
}

export function getServiceType() {
    return getCookie(SERVICE)
}

export function getAllToken() {
    if (!getCookie(SERVICE_TOKEN)) return {}
    return {
        access_token: getCookie(SERVICE_TOKEN),
        expires_on: getCookie(SERVICE_TOKEN_EXPIRES),
    }
}
export function getToken() {
    if (!getCookie(SERVICE_TOKEN)) return {}
    return {
        service_token: getCookie(SERVICE_TOKEN),
        service_expires_on: getCookie(SERVICE_TOKEN_EXPIRES),
        user_id: getCookie(USER_ID),
        bsrsToken: getCookie(BSRS_ACCESS_TOKEN),
        isIntegration: getCookie(IS_INTEGRATION),
        access_token: getCookie(ACCESS_TOKEN),
        expires_on: getCookie(EXPIRES_ON),
        refresh_token: getCookie(REFRESH_TOKEN)
    }
}
export function setToken({
    token,
    expires_on,
}) {
    setCookie(SERVICE_TOKEN, token)
    setCookie(SERVICE_TOKEN_EXPIRES, expires_on)
}

export function clearToken() {
    removeCookie(ACCESS_TOKEN)
    removeCookie(EXPIRES_ON)
    removeCookie(REFRESH_TOKEN)
}

export function getUserInfo(access_token) {
    if (!access_token) return {}

    // const {
    // //   iat,
    // //   exp,
    // //   appid,
    // //   name,
    // //   unique_name: email
    // } = jwt.decode(access_token)

    return {
        //   iat,
        //   exp,
        //   appid,
        //   name,
        //   email
    }
}

export function getBSRSToken() {
    return getCookie(BSRS_ACCESS_TOKEN)
}
export function getUserEmail() {
    return getCookie(USER_EMAIL)
}
export function getUserId() {
    return getCookie(USER_ID)
}

export function getTimeZone() {
    return getCookie(TIME_ZONE)
}

export function getUserInformation() {
    let firstName = getCookie(FIRSTNAME)
        , lastName = getCookie(LASTNAME)
        , email = getCookie(USER_EMAIL)
        , service = getCookie(SERVICE)
        , id = getCookie(USER_ID)
    return { firstName, lastName, email, service, id }
}

export function getTokenExpire() {
    return getCookie(TOKEN_EXPIRE)
}
export function setBSRSToken(bsrsToken) {
    const { isIntegration, token, id, o365_token, o365_token_expire_on, email, isUserActiveDirectory, timeZone, firstName, lastName, service } = bsrsToken
    setCookie(BSRS_ACCESS_TOKEN, token)
    // setCookie(SERVICE_TOKEN, access_token)
    // setCookie(SERVICE_TOKEN_EXPIRES, expires_on)
    setCookie(IS_INTEGRATION, isIntegration)
    setCookie(USER_ID, id)
    setCookie(O365_TOKEN, o365_token ? o365_token : "")
    setCookie(O365_EXPIRES_ON, o365_token_expire_on ? o365_token_expire_on : "")
    setCookie(USER_EMAIL, email ? email : "")
    // setCookie(TOKEN_EXPIRE, token_expire)
    setCookie(IS_USER_AD, isUserActiveDirectory)
    setCookie(TIME_ZONE, timeZone)
    setCookie(FIRSTNAME, firstName)
    setCookie(LASTNAME, lastName)
    setCookie(SERVICE, service)
}
export function setUserInfo({ firstName, lastName }) {
    setCookie(FIRSTNAME, firstName)
    setCookie(LASTNAME, lastName)
}
export function setRefreshToken(res) {
    if (res.value) {
        const { serviceToken, token, user } = res.value
        let o365_token = null, o365_token_expire_on = null
        if (user.token) {
            user.token.forEach(token => {
                const { data: { access_token, expires_on } } = token
                o365_token = access_token
                o365_token_expire_on = expires_on
            })
        }
        const { access_token, expires_on } = serviceToken
        let token_expire = expires_on > o365_token_expire_on ? o365_token_expire_on : expires_on
        // let bsrsToken = { access_token, token, o365_token, token_expire }
        setCookie(SERVICE_TOKEN, access_token)
        setCookie(BSRS_ACCESS_TOKEN, token)
        setCookie(O365_TOKEN, o365_token ? o365_token : "")
        setCookie(TOKEN_EXPIRE, token_expire)
    }
}

export function clearBSRSToken() {
    removeCookie(BSRS_ACCESS_TOKEN)
    removeCookie(SERVICE_TOKEN)
    removeCookie(SERVICE_TOKEN_EXPIRES)
    removeCookie(USER_ID)
    removeCookie(IS_INTEGRATION)
    removeCookie(ACCESS_TOKEN)
    removeCookie(EXPIRES_ON)
    removeCookie(REFRESH_TOKEN)
    removeCookie(O365_TOKEN)
    removeCookie(O365_EXPIRES_ON)
    removeCookie(USER_EMAIL)
    removeCookie(TOKEN_EXPIRE)
    removeCookie(IS_USER_AD)
    removeCookie(TIME_ZONE)
    removeCookie(SERVICE)
    removeCookie(FIRSTNAME)
    removeCookie(LASTNAME)
}


// WEBPACK FOOTER //
// ./src/lib/auth.js